/**
 * This function gets the domain/port for local development and the static environment.
 * It retrieves this value from an hidden input element on the HTML page. If this
 * element is not available (e.g. on testing and production), an empty string is
 * returned, so the current domain will be used.
 **/

function getXhrDomain() {
    const xhrDomainInputEl = document.querySelector('[name="xhrDomain"]');
    if (!xhrDomainInputEl) return '';
    return xhrDomainInputEl.value;
}

export { getXhrDomain };
